"use client";
import { useState, useCallback } from "react";

const useNavigationStack = (initialData, backToMainMenu) => {
  const [navigationStack, setNavigationStack] = useState([initialData]);

  const handleNavigateTo = useCallback((item) => {
    setNavigationStack((prevStack) => {
      const itemIndex = prevStack.findIndex((parent) =>
        parent?.children?.some((child) => child.title === item.title),
      );

      if (item?.children?.length) {
        return [...prevStack.slice(0, itemIndex + 1), item];
      }

      return prevStack.slice(0, itemIndex + 1);
    });
  }, []);

  const back = useCallback(() => {
    setNavigationStack((prevStack) => {
      if (prevStack.length <= 1) {
        backToMainMenu?.();
        return [];
      }
      return prevStack.slice(0, -1);
    });
  }, [backToMainMenu]);
  const currentNavigation = navigationStack[navigationStack.length - 1] || {};
  const isInShop = !!navigationStack.find((s) => s?.meta?.layout === "shop");
  const callToAction = isInShop
    ? navigationStack.find((s) => s?.callToAction)?.callToAction
    : currentNavigation?.children?.find(({ meta }) => meta?.isCallToAction);
  return {
    navigationStack,
    handleNavigateTo,
    back,
    currentNavigation: {
      ...currentNavigation,
      children: (currentNavigation?.children || [])?.filter(
        ({ meta }) => !meta?.isCallToAction,
      ),
    },
    callToAction,
  };
};

export default useNavigationStack;
